jQuery(document).ready(function($) {
  /**
   * Sticky header
   */
  var win = window;
  var body = document.body;
  var ticking = false;
  var stickyOffset = 126;

  function updateStickyHeader() {
    var scrollTop = win.pageYOffset || document.documentElement.scrollTop;
    var isSticky = scrollTop > stickyOffset;

    if ( isSticky !== body.classList.contains('sticky-header') ) {
      body.classList.toggle('sticky-header', isSticky);
    }

    ticking = false;
  }

  win.addEventListener('scroll', function() {

    if ( !ticking ) {
      win.requestAnimationFrame(updateStickyHeader);
      ticking = true;
    }

  }, {
    passive: true
  });

  updateStickyHeader();

  // Mobile navi
  $('button.hamburger').click(function() {
    $(this).find('span#nav-icon').toggleClass('open');
    $(this).toggleClass('open');
    $('body').toggleClass('navi-open');
    if ( $('body.navi-open').length > 0 ) {
      $('nav.main-navi').slideDown(300);
      $(this).attr('aria-expanded', 'true');
    }
    else {
      $('nav.main-navi').hide();
      $(this).attr('aria-expanded', 'false');
      $('form.search').hide();
    }
  });

  /**
  * Videot
  */
  const videoItems = document.querySelectorAll('.video-item');
  const previewTime = 6;

  videoItems.forEach(function(item) {
    const video = item.querySelector('video');
    const playButton = item.querySelector('.video-play');
    const stopButton = item.querySelector('.video-stop');

    if (!video || !playButton || !stopButton) {
      return;
    }

    video.controls = false;

    /**
     * Siirretään video pysäytyskuvan kohtaan.
     */
    function setPreviewFrame() {
      if (video.duration > previewTime) {
        video.currentTime = previewTime;
      } else {
        video.currentTime = 0;
      }
    }

    /**
     * Asetetaan pysäytyskuva, kun videon metadata
     * ja kesto ovat saatavilla.
     */
    /* video.addEventListener('loadedmetadata', function() {
      setPreviewFrame();
    }); */

    /**
     * Palautetaan video alkutilaan.
     */
    function resetVideo() {
      video.pause();
      video.controls = false;

      //setPreviewFrame();

      item.classList.remove('is-playing');
    }

    /**
     * Play.
     */
    playButton.addEventListener('click', function() {

      // Suljetaan mahdollinen toinen avoinna oleva video.
      videoItems.forEach(function(otherItem) {
        if (otherItem === item) {
          return;
        }

        const otherVideo = otherItem.querySelector('video');

        if (otherVideo) {
          otherVideo.pause();
          otherVideo.controls = false;

          if (otherVideo.duration > previewTime) {
            otherVideo.currentTime = previewTime;
          } else {
            otherVideo.currentTime = 0;
          }
        }

        otherItem.classList.remove('is-playing');
      });

      item.classList.add('is-playing');

      // Aloitetaan varsinainen video alusta.
      video.currentTime = 0;
      video.controls = true;

      video.play();
    });

    /**
     * Stop.
     */
    stopButton.addEventListener('click', function() {
      resetVideo();
    });

    /**
     * Kun video päättyy, palataan alkutilaan.
     */
    video.addEventListener('ended', function() {
      resetVideo();
    });
  });

  /**
   * Referenssikaruselli
   */
  const referenceCarousels = document.querySelectorAll('.referenssi-carousel');

  referenceCarousels.forEach(function(carousel) {
    const slides = carousel.querySelectorAll('.referenssi-slide');
    const dots = carousel.querySelectorAll('.carousel-dot');
    const prevButton = carousel.querySelector('.carousel-prev');
    const nextButton = carousel.querySelector('.carousel-next');

    if (slides.length < 2) {
      return;
    }

    let currentIndex = 0;
    let interval = null;
    let autoplayEnabled = true;

    function showSlide(index) {
      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      slides.forEach(function(slide) {
        slide.classList.remove('is-active');
      });

      dots.forEach(function(dot) {
        dot.classList.remove('is-active');
      });

      slides[index].classList.add('is-active');

      if (dots[index]) {
        dots[index].classList.add('is-active');
      }

      currentIndex = index;
    }

    function stopAutoplay() {
      autoplayEnabled = false;

      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled) {
        return;
      }

      interval = setInterval(function() {
        showSlide(currentIndex + 1);
      }, 7000);
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        stopAutoplay();
        showSlide(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        stopAutoplay();
        showSlide(currentIndex + 1);
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        stopAutoplay();

        const index = parseInt(dot.dataset.index, 10);

        showSlide(index);
      });
    });

    startAutoplay();
  });
});
// /document.ready